const MVV_DATA = [
  {
    key: 'Mission',
    label: 'ミッション',
    kana: 'MISSION',
    text: '住環境を最適化し、人生に「余白」と「選択肢」を生み出す',
    desc: '経済的なゆとり（①）と、心身が整う住空間（②）を提供することで、お客様が将来の不安から解放され、前向きに人生を選択できる土台をつくります。',
    color: 'text-[#1e3a70]',
    bg: 'bg-[#eef3fb]',
    border: 'border-[#b8cce8]',
    iconBg: 'bg-[#dce6f5]',
    label_en: 'M',
    values: null,
  },
  {
    key: 'Vision',
    label: 'ビジョン',
    kana: 'VISION',
    text: '子育てから介護まで、一生涯を心身ともに健やかに過ごせる住まいを実現する',
    desc: 'ライフステージが変化しても、経済的に困窮せず、物理的にも安全で、家族が穏やかに暮らし続けられる住環境の提供を目指します。',
    color: 'text-orange-500',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    iconBg: 'bg-orange-100',
    label_en: 'V',
    values: null,
  },
  {
    key: 'Values',
    label: 'バリュー',
    kana: 'VALUES',
    text: '私たちが大切にする4つの行動指針',
    desc: null,
    color: 'text-stone-600',
    bg: 'bg-stone-50',
    border: 'border-stone-200',
    iconBg: 'bg-stone-100',
    label_en: 'V',
    values: [
      {
        number: '01',
        title: '「家族視点」の徹底',
        subtitle: 'Family-Centric',
        desc: 'お客様を一組の「家族」として深く理解し、自分たちの家族に勧めることのできる誠実な選択肢のみを提案する。',
      },
      {
        number: '02',
        title: '「自走」を支えるコーチング',
        subtitle: 'Empowerment',
        desc: '一時的な解決ではなく、お客様自身が家計や環境を管理し、理想の暮らしを維持・更新し続けられる「力」を養う支援をする。',
      },
      {
        number: '03',
        title: '心身の安全・安心を土台にする',
        subtitle: 'Safe & Sound',
        desc: '無理なローンによる破綻を防ぎ（①）、住空間での事故やストレスを未然に防ぐ（②）。常に「リスク回避」を提案の出発点とする。',
      },
      {
        number: '04',
        title: '「余白」をデザインする',
        subtitle: 'Designing Margin',
        desc: '金銭的にも空間的にも、詰め込みすぎない「余裕」を持たせる。その余白が、不測の事態への備えと、心豊かな時間につながると信じる。',
      },
    ],
  },
];

export default function MVVSection() {
  return (
    <section id="mvv" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-[#1e3a70] text-sm font-medium tracking-widest uppercase mb-3">MISSION / VISION / VALUES</p>
          <h2 className="text-3xl font-bold text-stone-800 mb-4">私たちの想い</h2>
          <p className="text-stone-500 text-base max-w-xl mx-auto leading-relaxed">
            建てサポ事業と整理収納アドバイザー事業を通じて、私たちが大切にしている考え方をお伝えします。
          </p>
        </div>

        <div className="space-y-6">
          {MVV_DATA.map((item) => (
            <div key={item.key} className={`border ${item.border} rounded-2xl p-8 hover:translate-y-[-2px] transition-all duration-300 ${item.bg}`}>
              <div className="flex flex-col lg:flex-row lg:items-start gap-6">
                <div className="flex items-center gap-4 lg:w-48 flex-shrink-0">
                  <div className={`w-12 h-12 ${item.iconBg} rounded-full flex items-center justify-center`}>
                    <span className={`${item.color} font-bold text-lg`} style={{ fontFamily: 'Noto Serif JP' }}>
                      {item.label_en}
                    </span>
                  </div>
                  <div>
                    <p className={`text-xs font-medium tracking-widest ${item.color}`}>{item.kana}</p>
                    <p className="text-stone-800 font-bold text-lg" style={{ fontFamily: 'Noto Serif JP' }}>{item.label}</p>
                  </div>
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-xl mb-3 leading-relaxed text-stone-800" style={{ fontFamily: 'Noto Serif JP' }}>
                    {item.text}
                  </p>
                  {item.desc && (
                    <p className="text-stone-500 text-sm leading-relaxed">
                      {item.desc}
                    </p>
                  )}
                  {item.values && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                      {item.values.map((v) => (
                        <div key={v.number} className="bg-white/70 rounded-xl p-4 border border-stone-200">
                          <div className="flex items-start gap-3">
                            <span className="text-stone-300 font-bold text-lg leading-none mt-0.5" style={{ fontFamily: 'Noto Serif JP' }}>{v.number}</span>
                            <div>
                              <p className="text-stone-800 font-semibold text-sm mb-0.5" style={{ fontFamily: 'Noto Serif JP' }}>{v.title}</p>
                              <p className="text-stone-400 text-xs tracking-wider mb-2">{v.subtitle}</p>
                              <p className="text-stone-500 text-sm leading-relaxed">{v.desc}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
